import React, { useMemo } from 'react'
import { InvoiceDeliveryItemDto } from '../../../api/dto/invoice-delivery.dto'
import { EmailTemplateTag } from './EmailTemplateTag'
import { countByTemplate } from './invoiceTemplates'
import {
  SelectedTemplateCount,
  SelectedTemplates,
} from './emailTemplates.styles'

interface SelectedTemplateSummaryProps {
  deliveries: InvoiceDeliveryItemDto[]
  selectedRowKeys: React.Key[]
}

/** What the bulk bar has selected, per email template: "OE1 × 2 · OE2 × 1". */
const SelectedTemplateSummary: React.FC<SelectedTemplateSummaryProps> = ({
  deliveries,
  selectedRowKeys,
}) => {
  const counts = useMemo(() => {
    const selected = new Set(selectedRowKeys)
    return countByTemplate(deliveries.filter((d) => selected.has(d.id)))
  }, [deliveries, selectedRowKeys])

  if (counts.length === 0) return null
  return (
    <SelectedTemplates role="group" aria-label="Selected per email template">
      {counts.map(({ template, count }) => (
        <SelectedTemplateCount key={template}>
          <EmailTemplateTag template={template} />× {count}
        </SelectedTemplateCount>
      ))}
    </SelectedTemplates>
  )
}

export { SelectedTemplateSummary }
